import type { LeCoffreAuthContext } from "@Front/Utils/lecoffreSessionCookieHelpers";

export type AuthFailureTeardownParams = {
	endpointContext: LeCoffreAuthContext;
	routeScopedActiveContext: LeCoffreAuthContext | null;
	liveSessionContext: LeCoffreAuthContext | null;
	endpointMatchesRouteFamily: boolean;
};

/**
 * Whether a 401 should tear down the session.
 * A live session of another family (e.g. customer cookies on a `/folders` URL)
 * must not be destroyed because a notary API call failed.
 */
export function shouldTeardownSessionOnAuthFailure(params: AuthFailureTeardownParams): boolean {
	if (params.routeScopedActiveContext) {
		return params.endpointContext === params.routeScopedActiveContext;
	}
	if (params.liveSessionContext && params.liveSessionContext !== params.endpointContext) {
		return false;
	}
	return params.endpointMatchesRouteFamily;
}
